import { render, staticRenderFns } from "./ParametresMenu.vue?vue&type=template&id=9af2e7da&scoped=true&"
import script from "./ParametresMenu.vue?vue&type=script&lang=js&"
export * from "./ParametresMenu.vue?vue&type=script&lang=js&"
import style0 from "./ParametresMenu.vue?vue&type=style&index=0&id=9af2e7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af2e7da",
  null
  
)

export default component.exports